<template slot-scope="scope">
  <!-- 发票信息管理页面  弹窗组件 -->
      <dialogModel
        :title="moduleTitle"
        :visible="dialogIncident"
        @handleClose="handleClose"
        @handleOk="handleOk"
      >
        <div class="main-body">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <!-- 添加 / 编辑地址 -->
            <div class="content" v-if="Toggle == 1 || Toggle == 3">
              <el-form-item prop="AddressInput" style="margin-bottom: 20px">
                <p><span style="color: red">*</span>地址：</p>
                <el-input
                  v-model="ruleForm.AddressInput"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item prop="AddressPhone">
                <p><span style="color: red">*</span>电话：</p>
                <el-input
                  v-model="ruleForm.AddressPhone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <!-- 添加/编辑 电子邮箱 -->
            <div class="content" v-if="Toggle == 2 || Toggle == 4">
              <el-form-item prop="email">
                <p><span style="color: red">*</span>电子邮箱：</p>
                <el-input
                  v-model="ruleForm.email"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <!-- 删除 发票抬头 地址 电子邮箱 -->
            <div
              class="content content-dele"
              v-if="Toggle == 5 || Toggle == 6 || Toggle == 11"
            >
              <p class="dele-p">是否删除该发票信息?</p>
            </div>
            <!-- 添加/编辑 发票抬头信息 -->
            <div class="Look-up" v-if="Toggle == 9 || Toggle == 10">
              <div class="lookup-row">
                <div class="lookup-label">
                  <span style="color: red">*</span>发票类型：
                </div>
                <div class="lookup-field ipt-container">
                  <div
                    class="ipt-container-for"
                    v-for="(item, index) in TypeArr"
                    :key="index"
                  >
                    <div
                      :class="
                        SelectType == item.id ? 'Select-div' : 'notSelect-div'
                      "
                      @click="handelClick(item)"
                    ></div>
                    <p>{{ item.name }}</p>
                  </div>
                </div>
              </div>
              <div class="lookup-row">
                <div class="lookup-label">
                  <span style="color: red">*</span>发票抬头：
                </div>
                <div class="lookup-field">
                  <el-form-item prop="LookUp">
                    <el-input
                      v-model="ruleForm.LookUp"
                      placeholder="请输入发票抬头"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="lookup-row">
                <div class="lookup-label">
                  <span style="color: red">*</span>统一社会信用代码：
                </div>
                <div class="lookup-field">
                  <el-form-item prop="unifyCode">
                    <el-input
                      v-model="ruleForm.unifyCode"
                      placeholder="请输入企业统一社会信用代码"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="lookup-row">
                <div class="lookup-label">
                  <span style="color: red">*</span>法人姓名：
                </div>
                <div class="lookup-field">
                  <el-form-item prop="name">
                    <el-input
                      v-model="ruleForm.name"
                      placeholder="请输入法人姓名"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="lookup-row">
                <div class="lookup-label">
                  <span style="color: red">*</span>法人身份证：
                </div>
                <div class="lookup-field">
                  <el-form-item prop="standing">
                    <el-input
                      v-model="ruleForm.standing"
                      placeholder="请输入法人身份证号"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="lookup-row">
                <div class="lookup-label">
                  <span style="color: red">*</span>手机号：
                </div>
                <div class="lookup-field">
                  <el-form-item prop="phone">
                    <el-input
                      v-model="ruleForm.phone"
                      placeholder="请输入法人手机号"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="lookup-row">
                <div class="lookup-label">
                  <span style="color: red">*</span>验证码：
                </div>
                <div class="lookup-field ipt-container">
                  <el-form-item prop="Code">
                    <div style="display: flex">
                      <el-input
                        v-model="ruleForm.Code"
                        placeholder="请输入"
                      ></el-input>
                      <p
                        class="verify"
                        @click="second == 60 ? handelInvoke() : ''"
                      >
                        {{
                          second === totalSecond && sendNum == 0
                            ? "获取验证码"
                            : second === totalSecond && sendNum != 0
                            ? "再次获取验证码"
                            : second + `s`
                        }}
                      </p>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="lookup-row">
                <div class="lookup-label">开户银行名称：</div>
                <div class="lookup-field">
                  <el-input
                    v-model="ruleForm.bank"
                    placeholder="请输入合法的开户银行信息"
                  ></el-input>
                </div>
              </div>
              <div class="lookup-row">
                <div class="lookup-label">开户账号：</div>
                <div class="lookup-field">
                  <el-form-item prop="number">
                    <el-input
                      v-model="ruleForm.number"
                      placeholder="请输入合法的开户行账号"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="lookup-row">
                <div class="lookup-label">住所：</div>
                <div class="lookup-field">
                  <el-input
                    v-model="ruleForm.address"
                    placeholder="请输入合法的住所"
                  ></el-input>
                </div>
              </div>
              <div class="lookup-row">
                <div class="lookup-label">注册固定电话：</div>
                <div class="lookup-field">
                  <el-form-item prop="FixedLine">
                    <el-input
                      v-model="ruleForm.FixedLine"
                      placeholder="请输入合法的注册电话联系方式"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <!-- 设置默认 -->
            <div
              class="content content-dele"
              v-if="Toggle == 7 || Toggle == 8 || Toggle == 12"
            >
              <p class="dele-p" v-if="Toggle == 12">
                确认设置该条信息为默认发票抬头信息?
              </p>
              <p class="dele-p" v-if="Toggle == 7">
                确认设置该条信息为默认地址?
              </p>
              <p class="dele-p" v-if="Toggle == 8">
                确认设置该条信息为默认电子邮箱?
              </p>
            </div>
          </el-form>
        </div>
      </dialogModel>
</template>

<script>
import {
  postSendAuthCode, // 获取邮箱/手机验证码
} from "../../../../../../assets/api/index";
import { vxRule } from "../../../../../../../untils/FormValidation/validate-form";
export default {
  props: {
    dialogIncident: {},
    Toggle: {}, //切换 ， 1.添加地址 2.添加邮箱 3.编辑地址 4.编辑邮箱 5.删除地址 6.删除邮箱 7.地址设为默认 8.邮箱设为默认 9.添加发票抬头 10.编辑发票抬头 11.删除发票抬头 12.发票抬头设为默认
    moduleTitle: {}, // 标题
    inputEcho: {}, //编辑数据回显
  },
  components: {},
  data() {
    return {
      TypeArr: [
        { name: "增值税普通发票", id: "0" },
        { name: "增值税专用发票", id: "1" },
      ], // 发票类型
      ruleForm: {
        LookUp: "", //发票抬头
        unifyCode: "", //统一代码
        name: "", // 法人姓名
        standing: "", //法人身份证
        phone: "", //手机号
        Code: "", //验证码
        bank: "", //开户行名称
        number: "", //开户账号
        address: "", //住所
        FixedLine: "", //注册固定电话

        AddressInput: "", //邮寄地址
        AddressPhone: "", //电话
        email: "", //邮箱
      }, //输入框的双向绑定
      rules: {
        AddressInput: [
          {
            required: true,
            message: "请输入地址",
            trigger: ["blur", "change"],
          },
        ],
        AddressPhone: [
          {
            required: true,
            message: "请输入电话",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的电话号码",
            trigger: ["blur", "change"],
            pattern:
              /^\s*(1[3-9]\d{9})|((0\d{2,3})-?\d{7,8}(-\d{1,4})?)|(400|800)-?\d{3,4}-?\d{3,4}\s*$/,
          },
        ],
        email: [
          {
            required: true,
            message: "请输入电子邮箱",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          },
        ],

        LookUp: [
          {
            required: true,
            message: "请输入发票抬头",
            trigger: ["blur", "change"],
          },
        ],
        unifyCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur", "change"],
          },
         {
            pattern: /^[0-9A-HJ-NPQRSTUWXY]{18}$/,
            required: true,
            message: "请输入有效的18位统一社会信用代码",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "请输入法人姓名",
            trigger: ["blur", "change"],
          },
        ],
        standing: [
          {
            required: true,
            message: "请输入法人身份证号",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的身份证号码",
            trigger: ["blur", "change"],
            pattern:
              /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          },
        ],
        Code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: ["blur", "change"],
          },
          // {
          //   pattern: /^[0-9]*$/,
          //   required: true,
          //   message: "请输入验证码",
          //   trigger: ["blur", "change"],
          // },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的电话号码",
            trigger: ["blur", "change"],
            pattern:
              /^\s*(1[3-9]\d{9})|((0\d{2,3})-?\d{7,8}(-\d{1,4})?)|(400|800)-?\d{3,4}-?\d{3,4}\s*$/,
          },
        ],
        number: [
          {
            pattern: /^\d{16,22}$/,
            message: "开户账号需为16-22位纯数字",
            trigger: ["blur", "change"],
          },
        ],
        FixedLine: [
          {
            pattern:
              /^\s*((1[3-9]\d{9})|((0\d{2,3})-?\d{7,8}(-\d{1,4})?)|(400|800)-?\d{3,4}-?\d{3,4})\s*$/,
            message: "请输入正确的注册固定电话",
            trigger: ["blur", "change"],
          },
        ],
      }, // 表单验证
      SelectType: "0", // 发票类型选中
      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
      sendNum: "0", // 发送次数首次叫获取验证码之后叫再次发送验证码
    };
  },
  watch: {
    dialogIncident: {
      handler(newSs, old) {
        if (newSs == false) {
          this.SelectType = "0"; // 发票类型选中重置

          clearInterval(this.timer);
          this.timer = null; // 重置定时器 id
          this.second = this.totalSecond; // 归位
          this.sendNum = "0";

          this.ruleForm = {
            LookUp: "", //发票抬头
            unifyCode: "", //统一代码
            name: "", // 法人姓名
            standing: "", //法人身份证
            phone: "", //手机号
            Code: "", //验证码
            bank: "", //开户行名称
            number: "", //开户账号
            address: "", //住所
            FixedLine: "", //注册固定电话

            AddressInput: "", //邮寄地址
            AddressPhone: "", //电话
            email: "", //邮箱
          }; //输入框的双向绑定
          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
          }, 500);
        }
      },
      immediate: false,
    },
    inputEcho: {
      handler(newSs, old) {
        if (this.Toggle == 3) {
          // 地址回显
          this.ruleForm.AddressInput = newSs.address;
          this.ruleForm.AddressPhone = newSs.phone;
        } else if (this.Toggle == 4) {
          // 邮箱回显
          this.ruleForm.email = newSs.mail;
        } else if (this.Toggle == 10) {
          // 抬头回显
          this.SelectType =
            newSs.invoiceType === undefined || newSs.invoiceType === null
              ? "0"
              : String(newSs.invoiceType); //发票类型 0普1专
          this.ruleForm.LookUp = newSs.headName; //发票抬头
          this.ruleForm.unifyCode = newSs.creditCode; //统一代码
          this.ruleForm.name = newSs.legalPersonName; // 法人姓名
          this.ruleForm.standing = newSs.legalPersonIdNum; //法人身份证
          this.ruleForm.phone = newSs.phone; //手机号

          this.ruleForm.bank = newSs.bankName; //开户行名称
          this.ruleForm.number = newSs.bankAccount; //开户账号
          this.ruleForm.address = newSs.registerAddress; //住所
          this.ruleForm.FixedLine = newSs.telephone; //注册固定电话
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  //销毁事件
  destroyed() {
    clearInterval(this.timer);
    this.timer = null; // 重置定时器 id
    this.second = this.totalSecond; // 归位
  },
  methods: {
    // ---------------------------- 点击发送验证码 接口 -----------------------
    handelInvoke(formName) {
      // 单独查看手机号是否校验成功
      this.$refs[formName].validateField("phone", (errMsg) => {
        if (errMsg) {
          console.log("校验未通过");
        } else {
          console.log("校验通过");
          // 获取验证码接口
          var data = {};
          data.data = {
            mobile: this.ruleForm.phone,
            type: 0,
            authCodeBusiness: "6",
          };
          postSendAuthCode(data).then((res) => {
            if (res.code == 0) {
              this.Countdown();
              this.$tool.PromptBox("success", "验证码已发送");
            } else {
              // 验证码发送失败
              // this.$tool.PromptBox("error", "验证码发送失败");
            }
          });
        }
      });
    },
    // -------------------------------- 发送验证码倒计时----------------------
    Countdown() {
      this.textCode = false;
      var that = this;
      setTimeout(function () {
        that.sendNum++;
        console.log(that.sendNum);
        // 时间间隔
      }, 1000);

      // 当前目前没有定时器开着，且 totalSecond 和 second 一致 (秒数归位) 才可以倒计时
      if (!this.timer && this.second === this.totalSecond) {
        console.log("111");
        // 开启倒计时
        this.timer = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            clearInterval(this.timer);
            this.timer = null; // 重置定时器 id
            this.second = this.totalSecond; // 归位
          }
        }, 1000);
      }
    },

    // 发票类型选择
    handelClick(item) {
      this.SelectType = item.id;
    },
    handleClose() {
      this.$emit("handleClose", this.Toggle);
    },
    // 确认按钮处理
    handleOk() {
      if (this.Toggle == 9 || this.Toggle == 10) {
        this.handleUnderstand1();
      } else if (
        this.Toggle == 5 ||
        this.Toggle == 6 ||
        this.Toggle == 7 ||
        this.Toggle == 8 ||
        this.Toggle == 11 ||
        this.Toggle == 12
      ) {
        this.$emit("handleUnderstand", this.Toggle);
      } else {
        this.handleUnderstand("ruleForm");
      }
    },
    // 抬头的编辑添加确认
    handleUnderstand1() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit(
            "handleUnderstand",
            this.Toggle,
            this.ruleForm,
            "",
            this.SelectType
          );
        }
      });
    },
    // 确认
    handleUnderstand(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.Toggle == 1 || this.Toggle == 3) {
            this.$emit(
              "handleUnderstand",
              this.Toggle,
              this.ruleForm.AddressInput,
              this.ruleForm.AddressPhone
            );
          } else if (this.Toggle == 2 || this.Toggle == 4) {
            // 初步验证成功
            // 邮箱编辑添加
            // 使用标准邮箱格式正则表达式校验
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (emailRegex.test(this.ruleForm.email)) {
              // 邮箱验证成功
              this.$emit("handleUnderstand", this.Toggle, this.ruleForm.email);
            } else {
              this.$tool.PromptBox("warning", "邮箱后缀验证失败");
            }
          } else {
            this.$emit("handleUnderstand", this.Toggle);
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item {
  margin-bottom: 0px;
  // height: 35px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}

/deep/.el-input__inner {
  width: 360px;
  height: 35px !important;
  border: 1px solid #409eff ;
}
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}

    .content-dele {
      width: 100%;
      height: 100px;
      display: flex;
      margin: auto;
      // border: 1px solid gold;
      .dele-p {
        // text-align: center;
        margin: auto;
      }
    }
    // 发票抬头信息
    .Look-up {
      width: 100%;
      max-width: 540px;
      min-height: 100px;
      font-size: 14px;
      color: #333333;
      margin: 0 auto;
      .lookup-row {
        display: flex;
        align-items: flex-start;
        margin-bottom: 18px;
      }
      .lookup-label {
        width: 150px;
        flex-shrink: 0;
        text-align: right;
        line-height: 35px;
        padding-right: 8px;
        box-sizing: border-box;
      }
      .lookup-field {
        flex: 1;
        min-width: 0;
      }
      .ipt-container {
        width: 100%;
        min-height: 35px;
        line-height: 35px;
        display: flex;
        position: relative;
        .verify {
          position: absolute;
          right: 15px;
          color: #409eff ;
          cursor: pointer;
        }
        .ipt-container-for {
          display: flex;
          margin-right: 30px;
        }
        .notSelect-div {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          margin: auto 0;
          margin-right: 10px;
          background-image: url("../../../../../../assets/imgs/weigouxuan@3x.svg");
          background-size: 100% 100%;
          cursor: pointer;
        }
        .Select-div {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          margin: auto 0;
          margin-right: 10px;
          background-image: url("../../../../../../assets/imgs/gouxuan@3x.svg");
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
    }
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}

// 输入框
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
}
</style>
